import styles from "../CategorizedNomenclatureListPage.module.scss";
import { IconType } from "../../icons/Icon";
import { ItemsList } from "../../components/itemsList/ItemsList";
import { ISwipableAction } from "../../components/itemsList/types/ItemsList.types";
import { ICategorizableItem } from "../models/categorizedNomenclatureModels";

interface ICategoryItemsListProps<TItemModel extends ICategorizableItem> {
  items: TItemModel[];
  isLoading: boolean;
  emptyListText: string;
  itemTemplate: (
    item: TItemModel | undefined,
    index: number,
    isLoading: boolean,
    actionButtons?: React.ReactNode,
    className?: string,
    onEditItem?: (item: TItemModel) => void
  ) => JSX.Element;
  onItemClick?: (item: TItemModel) => void;
  onEditItem?: (item: TItemModel) => void;
  toggleDeletionEndpoint: string;
  updateEndpoint: string;
  invalidateKeys: (string | number | undefined)[][];
  isDeletedCategory?: boolean;
}

export const CategoryItemsList = <TItemModel extends ICategorizableItem>({
  items,
  isLoading,
  emptyListText,
  itemTemplate,
  onItemClick,
  onEditItem,
  toggleDeletionEndpoint,
  updateEndpoint,
  invalidateKeys,
  isDeletedCategory = false,
}: ICategoryItemsListProps<TItemModel>) => {
  const swipeLeftActions: ISwipableAction<any>[] = isDeletedCategory
    ? [
        {
          enablePrompt: true,
          promptMessage: "Да възстановим ли записа?",
          type: "other",
          method: "put",
          iconType: IconType.PutBackIcon,
          endpoint: toggleDeletionEndpoint,
          validator: (item: any) => item.isDeleted ?? false,
          invalidateKeys,
        },
      ]
    : [
        {
          enablePrompt: true,
          promptMessage: "Сигурни ли сте, че искате да изтриете този запис?",
          type: "other",
          method: "put",
          iconType: IconType.DeleteIcon,
          endpoint: toggleDeletionEndpoint,
          validator: (item: any) => !item.isDeleted,
          invalidateKeys,
        },
      ];

  const swipeRightActions: ISwipableAction<any>[] = isDeletedCategory
    ? []
    : [
        {
          type: "onClick",
          iconType: IconType.EditIcon,
          permissionRoute: updateEndpoint,
          onClick: (item: any) => onEditItem?.(item),
          validator: (item: any) => !item.isDeleted,
        },
      ];

  return (
    <ItemsList
      isLoading={isLoading}
      className={styles.category_items}
      items={items as any[]}
      noItemsText={emptyListText}
      itemTemplate={(item, index, actionButtons, className) => (
        <div
          onClick={() => onItemClick?.(item as TItemModel)}
          style={{ width: "100%" }}
        >
          {itemTemplate(
            item as TItemModel,
            index,
            isLoading,
            actionButtons,
            className,
            onEditItem
          )}
        </div>
      )}
      swipeLeftActions={swipeLeftActions}
      swipeRightActions={swipeRightActions}
      fullHeight={false}
      noWrapper
    />
  );
};
